import React, { useState } from "react";
import Flag from "react-world-flags";
import CustomSwitch from "../../../../controls/CustomSwitch";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoWarning } from "react-icons/io5";

export default function AdvisedVaccine({ mainColor, tripCountries }) {
  const vaccineItems = [
    {
      id: 1,
      name: "Hepatitis A Vaccine",
      desc: "Protects against Hepatitis A virus, typically spread through contaminated food or water.",
      price: "62.00",
    },
    {
      id: 2,
      name: "Typhoid Vaccine",
      desc: "Recommended for travel to areas with lower sanitation standards. Helps prevent typhoid fever.",
      price: "62.00",
    },
    {
      id: 3,
      name: "Rabies Vaccine",
      desc: "Recommended for extended stays in rural areas or for travelers involved in outdoor activities.",
      price: "120.00",
    },
  ];

  return (
    <div className="vaccine-suggestion-box advised-box">
      <div className="top-header">
        <p>Advised</p>
        <IoWarning size={18} />
      </div>
      <div className="body">
        <div className="header">
          <p>Highly Recommended</p>
          <div className="flags">
            {tripCountries.map((country) => (
              <div className="flag-container">
                <Flag key={country.code} code={country.code} />
              </div>
            ))}
          </div>
        </div>

        <div className="content">
          <div className="vaccine-items-wrapper">
            {vaccineItems.map((item) => {
              return (
                <div className="vaccine-item-box" key={item.id}>
                  <div className="header">
                    <p className="title">{item.name}</p>
                    <p className="price">
                      {item.price?.toUpperCase() !== "FREE" && "£"}
                      {item.price}
                    </p>
                  </div>

                  <p className="desc">{item.desc}</p>

                  <div className="switch-box">
                    <div>
                      <p className="title">I already have this vaccine</p>
                    </div>
                    <CustomSwitch mainColor={mainColor} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
